import React from "react";
import { twMerge } from "tailwind-merge";

/**
 * @typedef {object} LabelProps - The props for the component
 * @property {string} value - The value of the label
 * @property {string} htmlFor - The id of the element the label is for
 * @property {string} [classes] - extra classes for display purposes
 * @property {boolean} showAsterisk - Whether to show the asterisk or not
 */

/**
 * Renders a HTML label
 * @param {LabelProps} props - props
 * @returns {React.JSX.Element} The label
 */
function Label({ value, htmlFor, showAsterisk = false, classes }) {
  const classNames = twMerge(classes, "fr-block");
  return (
    <label htmlFor={htmlFor} className={classNames}>
      {value && (
        <>
          {value}
          {showAsterisk && (
            <>
              <span className="fr-text-red-600">*</span>
              <span className="fr-sr-only">(This field is required)</span>
            </>
          )}
        </>
      )}
    </label>
  );
}

export default Label;
